import axios from "axios";
import { toast } from "react-toastify";

export const downloadReportByDateRange = async (reportType, startDate, endDate) => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    if (!authToken) {
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`
    }

    const queryParams = new URLSearchParams({
        is_downloaded: true
    });

    let endpoint;

    if (reportType === "leads") {
        queryParams.append("created_from", startDate);
        queryParams.append("created_to", endDate);
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-lead-report?${queryParams.toString()}`;
    }
    else if (reportType === "applications") {
        queryParams.append("created_from", startDate);
        queryParams.append("created_to", endDate);
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-application-report?${queryParams.toString()}`;
    }
    else if (reportType === "limit-sanction") {
        queryParams.append("loan_creation_from", startDate);
        queryParams.append("loan_creation_to", endDate);
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-loan-report?${queryParams.toString()}`;
    }
    else if (reportType === "tranche") {
        queryParams.append("from_date", startDate);
        queryParams.append("to_date", endDate);
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-tranche-report?${queryParams.toString()}`;
    }
    else if (reportType === "supplier") {
        queryParams.append("from_date", startDate);
        queryParams.append("to_date", endDate);
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-supplier-report?${queryParams.toString()}`;
    }
    else if (reportType === "demand") {
        queryParams.append("from_loan_date", startDate);
        queryParams.append("to_loan_date", endDate);
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-demand-report?${queryParams.toString()}`;
    }
    else if (reportType === "repayment") {
        queryParams.append("loan_creation_from", startDate);
        queryParams.append("loan_creation_to", endDate);
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-rps-report?${queryParams.toString()}`;
    }
    else if (reportType === "active-customer") {
        queryParams.append("loan_created_from", startDate);
        queryParams.append("loan_created_to", endDate);
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-active-customer-report?${queryParams.toString()}`;
    }
    else if (reportType === "payment-transaction") {
        queryParams.append("creation_start_date", startDate);
        queryParams.append("creation_end_date", endDate);
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/payments-transaction-report?${queryParams.toString()}`;
    }

    try {
        const response = await axios.get(endpoint, {
            headers,
            responseType: "blob"    // for CSV/PDF/Excel 
        });

        console.log("Response headers:", response.headers);
        console.log("Response raw data:", response.data);

        const blob = new Blob([response.data], { type: "text/csv" });
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', `${reportType}_${new Date().toISOString()}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        // console.log("Download Error: ", error)
        // toast.error(`Download failed: ${error?.response?.data?.message}`);

        console.log("Download Error: ", error);

        let errorMessage = "Download failed";

        try {
            // Attempt to parse the blob error message
            const reader = new FileReader();
            reader.onload = () => {
                try {
                    const parsed = JSON.parse(reader.result);
                    errorMessage = parsed?.message || errorMessage;
                    console.log("erroorr: ", errorMessage);
                    toast.error(errorMessage);
                } catch {
                    toast.error(errorMessage);
                }
            };
            reader.readAsText(error.response.data);
        } catch {
            toast.error(errorMessage);
        }
    }
}

export const getFilenameFromHeader = (header) => {
    if (!header) return null;

    const match = header.match(/filename="?([^"]+)"?/);
    return match ? match[1] : null;
};

export const downloadReport = async (reportType, filters) => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    if (!authToken) {
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`
    }

    // const cleanedFilters = sanitizeFilters(filters);

    // const queryParams = new URLSearchParams({
    //     ...cleanedFilters,
    //     is_downloaded: true
    // });

    const cleanedFilters = sanitizeFilters(filters);

    const queryParams = new URLSearchParams();

    Object.entries(cleanedFilters).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((v) => queryParams.append(key, v));
        } else {
            queryParams.append(key, value);
        }
    });

    queryParams.append('is_downloaded', true);


    let endpoint;

    if (reportType === "leads") {
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-lead-report?${queryParams.toString()}`;
    }
    else if (reportType === "applications") {
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-application-report?${queryParams.toString()}`;
    }
    else if (reportType === "limit-sanction") {
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-loan-report?${queryParams.toString()}`;
    }
    else if (reportType === "tranche") {
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-tranche-report?${queryParams.toString()}`;
    }
    else if (reportType === "supplier") {
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-supplier-report?${queryParams.toString()}`;
    }
    else if (reportType === "demand") {
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-demand-report?${queryParams.toString()}`;
    }
    else if (reportType === "repayment") {
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-rps-report?${queryParams.toString()}`;
    }
    else if (reportType === "active-customer") {
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-active-customer-report?${queryParams.toString()}`;
    }
    else if (reportType === "payment-transaction") {
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/payments-transaction-report?${queryParams.toString()}`;
    }
    else if (reportType === "query-management") {
        endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-qms-report?${queryParams.toString()}`;
    }

    try {
        const response = await axios.get(endpoint, {
            headers,
            responseType: "blob"    // for CSV/PDF/Excel 
        });

        const disposition = response.headers["content-disposition"];
        // console.log({ disposition });

        const serverFilename = getFilenameFromHeader(disposition);
        // console.log({ serverFilename });
        const finalFilename = serverFilename || `${reportType}_${new Date().toISOString()}.csv`;

        console.log("Response headers:", response.headers);
        console.log("Response raw data:", response.data);

        const blob = new Blob([response.data], { type: "text/csv" });
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        // link.setAttribute('download', `${reportType}_${new Date().toISOString()}.csv`);
        link.setAttribute('download', finalFilename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        console.log("Download Error: ", error);

        let errorMessage = "Download failed";

        try {
            // Attempt to parse the blob error message
            const reader = new FileReader();
            reader.onload = () => {
                try {
                    const parsed = JSON.parse(reader.result);
                    errorMessage = parsed?.message || errorMessage;
                    console.log("erroorr: ", errorMessage);
                    toast.error(errorMessage);
                } catch {
                    toast.error(errorMessage);
                }
            };
            reader.readAsText(error.response.data);
        } catch {
            toast.error(errorMessage);
        }
    }
}

export const resetFilters = (filters) => {
    return Object.entries(filters).reduce((acc, [key, value]) => {
        acc[key] = Array.isArray(value) ? [] : "";
        return acc;
    }, {});
}

export const sanitizeFilters = (filters) => {
  return Object.entries(filters).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      if (value.length) {
        acc[key] = value;
      }
    } else if (
      value !== "" &&
      value !== null &&
      value !== undefined
    ) {
      acc[key] = value;
    }
    return acc;
  }, {});
};